module.exports = __webpack_public_path__ + "static/media/pan2Correct.369ac9b2.png";